import { tabbedDataGridPage } from "../../styles/commonPageStyles";

// Portal-style layout: white header block with title + Reload,
// then the standard portal table filling the remaining height.
const styles = {
  mainBox: {
    ...tabbedDataGridPage.tabContentMainBox,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  headerGrid: { ...tabbedDataGridPage.gridContainer, flexShrink: 0 },
  // Compact filter row between the header and the table.
  filterStack: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "6px",
    mb: "8px",
    flexShrink: 0,
  },
  // 34px search input matching the FilterMultiSelect trigger height.
  searchField: {
    width: "260px",
    "& .MuiOutlinedInput-root": { height: "34px", fontSize: "13px" },
  },
  // Wider trigger for repository filters holding long names.
  filterButton: (filterName) => {
    if (/repo/i.test(filterName)) {
      return { minWidth: "220px", justifyContent: "space-between" };
    }
    return {};
  },
  // "{filtered} of {total}" on the right of the filter bar.
  countText: {
    ml: "auto",
    fontSize: "12px",
    color: "text.secondary",
    whiteSpace: "nowrap",
  },
  // Applied-filters row above the table; hidden when nothing is selected.
  appliedFiltersRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "6px",
    mb: "12px",
    flexShrink: 0,
  },
  appliedFiltersLabel: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.06em",
    color: "text.secondary",
  },
  // Soft blue tag chips (portal style); full value always visible.
  appliedFilterChip: (colors) => ({
    height: "22px",
    borderRadius: "4px",
    bgcolor: colors.qaBg,
    color: colors.qaFg,
    fontSize: "11px",
    fontWeight: 600,
    maxWidth: "none",
    "& .MuiChip-label": { overflow: "visible", textOverflow: "clip" },
    "& .MuiChip-deleteIcon": {
      fontSize: "14px",
      color: colors.infoFg,
      "&:hover": { color: colors.qaFg },
    },
  }),
  clearAllButton: {
    ml: "auto",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: 600,
    minWidth: 0,
    p: "2px 8px",
  },
  // Portal tdLink: 13px / 500 link cells.
  linkText: {
    fontSize: 13,
    fontWeight: 500,
  },
  dataTable: { flex: 1, minHeight: 0 },
};

export default styles;
